import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllPlayersService } from 'network/services/players.service'

export const fetchAllPlayers = createAsyncThunk(
  'fetch/allPlayers',
  async (data, thunkApi) => {
    try {
      const res = await getAllPlayersService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
